// src/app/core/customer/customer-feature.guard.ts

import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { CUSTOMER_CONFIG } from './customer.config';
import { AppKey, CustomerFeatureKey } from './customer-config.model';

/* --------------------------
   APP GUARD
--------------------------- */

export const canMatchCustomerApp: CanMatchFn = (route) => {
  const router = inject(Router);
  const appKey = route.data?.['appKey'] as AppKey | undefined;

  if (!appKey) {
    return true;
  }

  const appConfig = CUSTOMER_CONFIG.apps[appKey];

  // 🔥 FIX: check enabled, not truthy object
  if (appConfig?.enabled) {
    return true;
  }

  // 🔥 FIX: redirect based on default app
  const redirect = CUSTOMER_CONFIG.defaultRedirect[CUSTOMER_CONFIG.defaultApp];

  return router.parseUrl(redirect);
};

/* --------------------------
   FEATURE GUARD
--------------------------- */
export const canMatchCustomerFeature: CanMatchFn = (route) => {
  const router = inject(Router);
  const featureKey = route.data?.['featureKey'] as CustomerFeatureKey | undefined;

  if (!featureKey) {
    return true;
  }

  if (CUSTOMER_CONFIG.enabledFeatures.includes(featureKey)) {
    return true;
  }

  const redirect = CUSTOMER_CONFIG.defaultRedirect[CUSTOMER_CONFIG.defaultApp];
  return router.parseUrl(redirect);
};
